import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';

const Phone: FC<IconV2Props> = ({ className, icon }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={cn(`svg-icon--${icon}`, className)}
    width="25"
    height="25"
    viewBox="0 0 25 25"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-154.000000, -1062.000000)"
        fill="#000000"
        fillRule="nonzero"
      >
        <g transform="translate(154.493027, 1062.979725)">
          <path d="M16.0649846,13.3584229 L23.5415202,18.3425248 L23.1633289,18.9582735 L21.4441653,21.7570685 C21.0096035,22.4949004 20.3079229,23.0357863 19.4799097,23.2709661 L19.4735604,23.2727394 C15.7739634,24.2884776 11.3413186,22.2907065 6.28889563,17.2381968 C1.23523157,12.1844459 -0.760916572,7.75248391 0.258080941,4.04056313 C0.493420943,3.21217627 1.03999701,2.50869014 1.79550116,2.06720081 L5.42468417,0 L5.8049188,0.616362493 L6.18518311,1.23277312 L7.87519042,3.973215 L10.158253,7.47105327 L9.62909563,7.89670087 L9.09988595,8.32239051 L7.28685899,9.78023642 L7.31590647,9.83302031 C8.02041317,11.1251334 8.61710072,11.8940017 10.1244486,13.4011319 C11.6322082,14.9086433 12.4010725,15.5052308 13.6982007,16.2127658 L13.7451905,16.2386674 L16.0649846,13.3584229 Z M20.1588405,20.9839275 L21.5069734,18.788977 L16.3733946,15.3667663 L14.8061418,17.3123818 C14.4245295,17.8105148 13.7497678,17.9590702 13.211313,17.6571503 L12.9770548,17.5280368 C11.5484184,16.748778 10.6675192,16.0652588 9.06387043,14.461874 C7.46054195,12.8587771 6.7768241,11.9777649 6.000356,10.5536577 L5.8741147,10.3242213 C5.57114202,9.78374318 5.70798693,9.10623008 6.18458019,8.74207963 L8.15977211,7.15355093 L6.60879462,4.77687734 L4.90853077,2.02026643 L2.54514454,3.36641795 C2.13068988,3.60863978 1.830312,3.99524958 1.70277602,4.44406244 C0.859077945,7.51750943 2.6369561,11.4648559 7.34956491,16.1775457 C12.0592919,20.8873536 16.0063805,22.6671804 19.0732472,21.827138 C19.5294519,21.6966961 19.9136097,21.400046 20.1588405,20.9839275 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default Phone;
